import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.upsert.mutation.gql"
import type {
  TenantPrivacyPoliciesUpsertMutation,
  TenantPrivacyPoliciesUpsertMutationVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.upsert.mutation"

type Options = MutationHookOptions<
  TenantPrivacyPoliciesUpsertMutation,
  TenantPrivacyPoliciesUpsertMutationVariables
>

export function useTenantPrivacyPoliciesUpsertMutation(options?: Options) {
  return useMutation<
    TenantPrivacyPoliciesUpsertMutation,
    TenantPrivacyPoliciesUpsertMutationVariables
  >(mutation, options)
}
